'use client';

import { Drawer } from '@/components/drawer';
import { Text } from '@/components/text';

import { CartPlanListing } from './cart-plan-listing';

import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';

type CartProps = PropsWithChildren<{
  children: React.ReactNode;
  isCartDrawerOpen: boolean;
  setIsCartDrawerOpen: Dispatch<SetStateAction<boolean>>;
}>;

export const Cart = ({
  children,
  isCartDrawerOpen,
  setIsCartDrawerOpen,
}: CartProps) => {
  return (
    <Drawer
      isOpen={isCartDrawerOpen}
      setOpen={setIsCartDrawerOpen}
    >
      <div className="pb-e md:pb-d xl:pb-c">
        <Text
          variant="h4"
          as="h4"
          className="pb-c xl:pb-b"
        >
          Available offer
        </Text>
        {children}
      </div>
      <Text
        variant="h4"
        as="h4"
        className="pb-c xl:pb-b"
      >
        Your plans
      </Text>
      <CartPlanListing setIsCartDrawerOpen={setIsCartDrawerOpen} />
    </Drawer>
  );
};
